import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';

import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { fetchPannaData } from '../../Store/PHPSlice/Panna';
import { fetchSingleCloth, updateClothEntry } from '../../Store/PHPSlice/Cloth';
import { useParams } from 'react-router-dom';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';

const ClothEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const imgUrl = process.env.REACT_APP_IMAGE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        clothId: parseInt(Id),
        cloth: '',
        model: '',
        color: '',
        shade: '',
        panna: '',
        hsn: '',
        rate: '',
        uom: 'm',
        clothImg: '',
        userId: userdata?.ID
    });

    const [loading, setLoading] = useState(false);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const getPanas = useSelector((state) => state.PannaData.pana || { data: [] });
    const singleCloth = useSelector((state) => state.ClothData.singleCloth || { data: [] });
    useEffect(() => {
        dispatch(fetchPannaData());
        dispatch(fetchSingleCloth(Id));
    }, [dispatch]);

    useEffect(() => {
        if (singleCloth.data.length > 0) {
            const item = singleCloth.data[0];
            setFormData({
                ...formData,
                dt: item.dt,
                cloth: item.clothNm,
                model: item.model,
                color: item.color,
                shade: item.shadeNo,
                panna: item.panna_size,
                hsn: item.hsn,
                rate: item.rate,
                uom: item.uom,
                clothImg: item.clothImg,
            })
        }
    }, [singleCloth]);
    if (!getPanas && !singleCloth) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            image: e.target.files[0]
        });
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const result = await dispatch(updateClothEntry(formData)).unwrap();
            console.log('POST request successful!', result);
            alert("Cloth Added");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const dateinputFields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Cloth Name', name: 'cloth' },
        { label: 'Modal Name', name: 'model' },
        { label: 'Color', name: 'color' },
        { label: 'Shade No', name: 'shade' },
        { label: 'HSN', name: 'hsn' }
    ];

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Cloth Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>


                                {dateinputFields?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="panna">Panna :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="panna"
                                                    id="panna"
                                                    name="panna"
                                                    value={formData.panna}
                                                    onChange={(e) => handleDropdownChange(e, 'panna')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        getPanas?.data?.map((item, index) => (
                                                            <MenuItem key={index} value={item.panna_size}>{item.panna_size}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {[

                                    { label: 'Rate', name: 'rate' },
                                    { label: 'UOM', name: 'uom' },
                                    { label: 'Cloth Image', name: 'clothImg', type: 'file' },


                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {formData.clothImg !== "" ? <Grid item xs={12} md={6}>
                                    <p>Previous Image</p>
                                    <img
                                        src={`${imgUrl}/${formData.clothImg}`}
                                        style={{ width: '8vw', height: '10vh', margin: '0.5vw', cursor: 'pointer' }}
                                        alt="Item Thumbnail"
                                    />

                                </Grid> : null}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothEdit;